import Store from '../../helpers/store';

export default class AnitibioticsStore extends Store {
}


// WEBPACK FOOTER //
// ./js/models/antibiotics/antibioticsStore.js